import { EQIP_IRRIGATION_QUANTITY_OPTIONS } from '@cibo/core'
import { FormControlLabel, Radio, Stack, Typography } from '@mui/material'
import { Field, FieldProps } from 'formik'
import { RadioGroup } from 'formik-mui'
import { useTranslation } from 'react-i18next'
import { useFieldsOwner } from '../../../../hooks'
import { DetailEditorPropsByYear } from '../../types'

export const EqipIrrigationQuantityEditor = ({
  fieldModels,
  name = 'eqipPracticesIrrigationQuantity',
  requirement,
  year,
}: DetailEditorPropsByYear) => {
  const { t } = useTranslation('@cibo/landmanager/EqipIrrigationQuantity')

  const owner = useFieldsOwner(fieldModels)

  return (
    <Field name={name} id={name}>
      {({ form: { isSubmitting } }: FieldProps) => {
        return (
          <Stack spacing={2}>
            <Typography>
              {t('cta', {
                context: owner?.isSelf ? 'owner' : 'notOwner',
                count: fieldModels?.length,
                ownerName: owner?.displayName,
                period: year,
              })}
            </Typography>

            <Field name={`${name}.irrigationQuantity`} component={RadioGroup} row>
              {EQIP_IRRIGATION_QUANTITY_OPTIONS.map(answer => (
                <FormControlLabel
                  key={answer}
                  value={answer}
                  control={<Radio />}
                  label={`${t(`irrigationQuantity_${answer}`)}`}
                  disabled={isSubmitting}
                  data-testid={`${name}::${answer}`}
                />
              ))}
            </Field>
          </Stack>
        )
      }}
    </Field>
  )
}
